import {
  ApiBlueprint,
  createFrontendModule,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';

// --- API ---

export interface TechDocsViewsApi {
  recordVisit(entityRef: string): Promise<void>;
  getVisitors(entityRef: string): Promise<{
    visitors: Array<{
      user_ref: string;
      user_display_name: string;
      first_visited_at: string;
    }>;
    total: number;
  }>;
}

export const techdocsViewsApiRef = createApiRef<TechDocsViewsApi>({
  id: 'plugin.techdocs-views.api',
});

const techdocsViewsApiExtension = ApiBlueprint.make({
  name: 'techdocs-views-api',
  params: defineParams => defineParams(createApiFactory({
    api: techdocsViewsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) => ({
      async recordVisit(entityRef: string) {
        const baseUrl = await discoveryApi.getBaseUrl('techdocs-views');
        await fetchApi.fetch(`${baseUrl}/visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ entityRef }),
        });
      },
      async getVisitors(entityRef: string) {
        const baseUrl = await discoveryApi.getBaseUrl('techdocs-views');
        const resp = await fetchApi.fetch(
          `${baseUrl}/visitors/${encodeURIComponent(entityRef)}`,
        );
        return resp.json();
      },
    }),
  })),
});

// --- Addon Component ---

import TechDocsViewsAddon from './TechDocsViewsAddon';

const techdocsViewsAddon = AddonBlueprint.make({
  name: 'techdocs-views',
  params: {
    name: 'techdocs-views',
    location: 'Header',
    component: TechDocsViewsAddon,
  },
});

// --- Module ---

export const techdocsViewsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techdocsViewsAddon, techdocsViewsApiExtension],
});
